import { render, staticRenderFns } from "./ChangeKennelOwners.vue?vue&type=template&id=e7d3aff4"
import script from "./ChangeKennelOwners.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports